import { FieldError } from 'react-hook-form';
import classes from './styles.module.scss';
import { useId } from 'react';
import cn from 'classnames';

export default function Input({
	min,
	step,
	label,
	onChange,
	onBlur,
	type = 'text',
	size = 'md',
	placeholder = '',
	onFocus,
	error,
	name,
	value,
	withLabel = true,
	defaultValue = null,
	isRequired = false,
	isDisabled = false,
	className = '',
	labelClassName = '',
}: {
	min?: number | string;
	step?: number | string;
	name: string;
	label?: string;
	onChange?: (...event: any[]) => (void | Promise<void>) | React.ChangeEventHandler<HTMLInputElement> | undefined;
	onBlur?: (...event: any[]) => void | Promise<void>;
	type?: string;
	size?: 'md' | 'sm' | 'lg';
	placeholder?: string;
	onFocus?: (...event: any[]) => void | Promise<void>;
	error?: FieldError;
	withLabel?: boolean;
	value?: any;
	defaultValue?: any;
	isRequired?: boolean;
	isDisabled?: boolean;
	className?: string | string[];
	labelClassName?: string | string[];
}) {
	const id: string = useId();

	return (
		<label htmlFor={id} className={withLabel ? classes.label : ''}>
			{label && (
				<span
					className={cn(
						labelClassName,
						classes.label__title
					)}
				>
					{label}
				</span>
			)}
			<input
				id={id}
				autoComplete="off"
				onChange={onChange}
				onBlur={onBlur}
				type={type}
				name={name}
				value={value}
			className={cn(
				className,
				classes.input,
				{ [classes.error]: error },
				classes[`input--${size}`]
			)}
				min={min}
				step={step}
				placeholder={placeholder}
				onFocus={onFocus}
				defaultValue={defaultValue}
				required={isRequired}
				disabled={isDisabled}
			/>
			{error && <small className={classes.label__error}>{error.message}</small>}
		</label>
	);
}
